export default __webpack_public_path__ + "static/media/json-logo.d3901069.png";